export enum TipoSituacaoAssinaturaEnum {
    "Aguardando Início do Trâmite" = 1,
    "Aguardando Assinaturas Predecessoras" = 2,
    "Aguardando Assinatura" = 3,
    "Assinada" = 4,
    "Rejeitada" = 5,
    "Cancelada" = 6

}